import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Feature, LoggerService } from '../services/logger.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private loggerService: LoggerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(error => {
        if (error.status && error.status !== 0) {
          if (!this.shouldIgnoreHttpError(request, error.status)) {
            this.loggerService.error('ErrorInterceptor::intercept - Request failed', {
              feature: Feature.API,
              context: 'Status: ' + error.status + ', url:' + error.url + ', message: ' + error.message,
            });
          }
        }

        return throwError(() => error);
      }),
    );
  }

  private shouldIgnoreHttpError(request: HttpRequest<unknown>, errorStatus: number): boolean {
    if (errorStatus === 404) {
      // Library code check
      if (request.method === 'GET' && request.url.startsWith(environment.booksBaseUrl + '/featured/active')) {
        return true;
      } else if (request.method === 'GET' && request.url.startsWith(environment.projectBaseUrl)) {
        return true;
        // Book not found api
      } else if (
        request.method === 'GET' &&
        request.url.startsWith(environment.apiBaseUrl + '/books/' + window.location.href.split('/')[window.location.href.split('/').length - 2]) + '?'
      ) {
        return true;
      }
    }

    if (errorStatus === 400) {
      // Email check, email not valid
      if (request.method === 'POST' && request.url.startsWith(environment.usersBaseUrl + '/auth/email/exists')) {
        return true;
      } else if (request.method === 'POST' && request.url.startsWith(environment.usersBaseUrl + '/auth/email/login')) {
        return true;
      } else if (request.method === 'POST' && request.url.startsWith(environment.usersBaseUrl + '/auth/email/signup')) {
        return true;
        // Happen if the user is considered as a bot by the backend
      } else if (request.method === 'GET' && request.url.startsWith(environment.usersBaseUrl + '/auth/guest-user')) {
        return true;
        // Apple - email already exist
      } else if (request.method === 'POST' && request.url.startsWith(environment.usersBaseUrl + '/auth/apple')) {
        return true;
      } // Google - email already exist
    } else if (request.method === 'POST' && request.url.startsWith(environment.usersBaseUrl + '/auth/google')) {
      return true;
    }
    return false;
  }
}
